import { SvgIcon } from '@mui/material';

const NextDay = props => (
  <SvgIcon
    width='38.966'
    height='34.637'
    viewBox='0 0 38.966 34.637'
    {...props}
  >
    <g id='Group_110' data-name='Group 110' transform='translate(629 16)'>
      <g id='Group_37' data-name='Group 37' transform='translate(-629 -16)'>
        <path
          id='Path_13'
          data-name='Path 13'
          d='M273.844,8.008,258.524.065a.577.577,0,0,0-.531,0l-4.225,2.188,15.58,8.087Z'
          transform='translate(-235.456 0)'
          fill='#dc0032'
        />
        <path
          id='Path_14'
          data-name='Path 14'
          d='M198.03,48.339l-15.586-8.082-4.2,2.176,15.586,8.082Z'
          transform='translate(-165.385 -37.352)'
          fill='#dc0032'
        />
        <path
          id='Path_15'
          data-name='Path 15'
          d='M104.394,79.457l-4.387,2.274,15.586,8.082,4.387-2.274Z'
          transform='translate(-92.791 -73.723)'
          fill='#dc0032'
        />
        <path
          id='Path_16'
          data-name='Path 16'
          d='M6.639,130h6.223a1.046,1.046,0,0,1,0,2.093H6.639v.006H1.046a1.046,1.046,0,0,0,0,2.093H6.639v.006h6.223a1.046,1.046,0,0,1,0,2.093H6.639v.006H2.778a1.046,1.046,0,1,0,0,2.093H6.639v.006h6.223a1.046,1.046,0,1,1,0,2.093H6.639v.006H4.917a1.046,1.046,0,1,0,0,2.093H6.944l.007,0,15.274,7.92V132.963L6.639,124.881Z'
          transform='translate(0 -115.87)'
          fill='#dc0032'
        />
        <path
          id='Path_17'
          data-name='Path 17'
          d='M402.247,171.535l4.295-2.228v-3.85l-4.295,2.228Z'
          transform='translate(-373.222 -153.518)'
          fill='#dc0032'
        />
        <path
          id='Path_18'
          data-name='Path 18'
          d='M335.1,127.223v4.8a.577.577,0,0,1-.312.514l-5.449,2.829a.6.6,0,0,1-.266.063.583.583,0,0,1-.577-.577v-4.2l-4.491,2.326v17.543l15.274-7.92a.582.582,0,0,0,.312-.514V124.9Z'
          transform='translate(-300.627 -115.885)'
          fill='#dc0032'
        />
      </g>
    </g>
  </SvgIcon>
);

export default NextDay;
